import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import ReactGA from 'react-ga'
import { SkeletonTheme } from 'react-loading-skeleton'

import { ReactComponent as ChevronLeftIcon } from '../../../../assets/icons/chevron-left-icon.svg'

import moment from 'moment'
import Card from '../../../../components/Card'
import SideMenuTemplate from '../..//templates/SideMenu'
import Alert from '../../components/Form/Alert'
import DownloadCards from '../../../../components/DownloadCards'
import { useGetNotificationsById } from '../../../../hooks/useGetNotificationById'
import { useUpdateNotification } from '../../../../hooks/useUpdateNotification'
import { notificationTypes } from '../constants'
import { Checkbox } from '../../../../components/Form'

import * as S from './styles'

const NotificationDetail = () => {
  const history = useHistory()
  const { id } = useParams()
  const { professional, partner } = JSON.parse(localStorage.getItem('userData'))
  const { notification, handleGetNotificationById, loading } = useGetNotificationsById()
  const { handleUpdateNotificationToRead, handleUpdateNotificationToAccepted, loadingAcceptTerms } = useUpdateNotification()
  const [wasAccepted, setWasAccepted] = useState(false)

  const typeNotification = notificationTypes[notification?.notificationType]
  const isOfficial = notification?.notificationType === 'OFFICIAL'
  const professionalId = professional.id
  const partnerId = partner
  const notificationId = id
  const partnerData = notification?.partners.find(partner => partner.partner._id === partnerId && partner.professionals)
  const professionalData = partnerData?.professionals.find(prof => prof.professional._id === professionalId)
  const isRead = professionalData?.read

  useEffect(() => {
    handleGetNotificationById(notificationId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (notification && !isRead) handleUpdateNotificationToRead({ partnerId, notificationId, professionalId })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification])

  const handleAcceptTerms = () => {
    try {
      handleUpdateNotificationToAccepted({ partnerId, notificationId, professionalId }).then(req => req && setWasAccepted(true))
    } catch (error) {
    }
  }

  const handleBackPage = () => {
    history.push('/vets/notifications')
    ReactGA.pageview('/vets/notifications')
  }

  return (
    <SkeletonTheme baseColor="#D9D9D9">
      <SideMenuTemplate>
        <S.MainContainer>
          <S.Button onClick={handleBackPage} outline>
            <ChevronLeftIcon />
            Voltar
          </S.Button>
          <S.StyledCard>
            <Card loading={loading} padding='23px'>
              <Alert show={isOfficial}>
                Este é um comunicado jurídico, você deve se manifestar com a ação de “aceite” para confirmar que leu e está de acordo com as informações.
              </Alert>
              <S.Category official={isOfficial} backgroundColor={typeNotification?.backgroundColor}>
                <S.CategoryName color={typeNotification?.color} >{typeNotification?.type}</S.CategoryName>
              </S.Category>
              <S.TextBlock>
                <S.Subtitle>{notification?.name}</S.Subtitle>
                <S.Text>{notification?.message}</S.Text>
              </S.TextBlock>
              {notification?.files.length > 0 && <DownloadCards files={notification.files}/>}
              {isOfficial &&
                <Card loading={loadingAcceptTerms} margin='16px 0 0 0'>
                  {wasAccepted || professionalData.accepted
                    ? (<S.Text hasMargin>Você declarou que leu e está de acordo com as informações enviadas neste comunicado no dia <strong>{moment(professionalData.acceptedAt).format('DD/MM/YYYY')}</strong>.</S.Text>)
                    : <S.Label>
                      <Checkbox
                        disable={professionalData.accepted}
                        display='inline'
                        width='fit-content'
                        onChange={handleAcceptTerms} />
                      <S.Text hasMargin>Declaro que li e estou de acordo com as informações enviadas no comunicado acima.</S.Text>
                    </S.Label>
                  }
                </Card>
              }
            </Card>
          </S.StyledCard>
        </S.MainContainer>
      </SideMenuTemplate>
    </SkeletonTheme>
  )
}

export default NotificationDetail
